// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function RoleCount(props) {
  var countText = "+" + String(props.count);
  return JsxRuntime.jsx("p", {
              children: countText,
              className: "font-bold text-teal-500"
            });
}

var make = RoleCount;

exports.make = make;
/* react/jsx-runtime Not a pure module */
